import { IconInterface } from '../interfaces/icon.interface';

export const TFTruck = (props: IconInterface) => {
	const {
		isActive,
		color = '#A2A2A2',
		strokeWidth = '1',
		hoverEffect = false,
	} = props;

	return (
		<svg
			width="24"
			height="20"
			viewBox="0 0 24 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
		>
			<path
				d="M15.4848 4.91992H16.5916C17.7114 4.91992 18.6841 5.6899 18.9412 6.77972L19.5655 9.0214C19.6558 9.40415 19.9269 9.71892 20.292 9.86497L21.9684 10.5355C22.4267 10.7188 22.7272 11.1627 22.7272 11.6563V15.9825C22.7272 16.649 22.187 17.1894 21.5204 17.1896L20.3131 17.1899M20.3131 17.1899C20.3131 18.1898 19.5024 19.0005 18.5025 19.0005C17.5025 19.0005 16.6919 18.1892 16.6919 17.1893M20.3131 17.1899C20.3131 16.1899 19.5024 15.3793 18.5025 15.3793C17.5025 15.3793 16.6919 16.1893 16.6919 17.1893M2.8106 17.1893H2.20707C1.54042 17.1893 1 16.6488 1 15.9822V14.1722C1 13.5055 1.54042 12.9651 2.20707 12.9651H4.01767M2.8106 17.1893C2.8106 18.1892 3.62123 19.0005 4.6212 19.0005C5.62117 19.0005 6.4318 18.1898 6.4318 17.1899C6.4318 16.1899 5.62117 15.3793 4.6212 15.3793C3.62123 15.3793 2.8106 16.1893 2.8106 17.1893ZM16.6919 17.1893L10.6565 17.1899M10.6565 17.1899C10.6565 18.1898 9.8459 19.0005 8.84593 19.0005C7.84597 19.0005 7.03533 18.1898 7.03533 17.1899C7.03533 16.1899 7.84597 15.3793 8.84593 15.3793C9.8459 15.3793 10.6565 16.1899 10.6565 17.1899ZM17.8989 11.7581H16.6919"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
			<path
				d="M4.13281 12.9689H12.7467C13.299 12.9689 13.7467 12.5212 13.7467 11.9689L13.747 5.92101V4.0275C13.747 3.47521 14.1947 3.0275 14.747 3.0275H15.6187C16.171 3.0275 16.6187 2.57978 16.6187 2.0275V2C16.6187 1.44772 16.171 1 15.6187 1H12.467C12.2043 1 11.9522 1.10338 11.765 1.2878L10 3.0275"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
			<path
				d="M6 3V9"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
			<circle
				cx="6"
				cy="6"
				r="5"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
			<path
				d="M7.5 4.75C7.5 4.05964 6.82843 3.5 6 3.5C5.17157 3.5 4.5 4.05964 4.5 4.75C4.5 5.44036 5.17157 6 6 6C6.82843 6 7.5 6.55964 7.5 7.25C7.5 7.94036 6.82843 8.5 6 8.5C5.17157 8.5 4.5 7.94036 4.5 7.25"
				stroke={isActive ? 'white' : color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				className={hoverEffect ? 'transition group-hover:stroke-black' : ''}
			/>
		</svg>
	);
};
